import { render, staticRenderFns } from "./manual_assign.vue?vue&type=template&id=22e462eb&scoped=true&"
import script from "./manual_assign.vue?vue&type=script&lang=js&"
export * from "./manual_assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e462eb",
  null
  
)

export default component.exports